import { DrawerContent, Drawer } from '@ui/components';
import { useState, FC } from 'react';

import { CurrentUserPermissionTransfer } from '../current-user-permission-transfer/current-user-permission-transfer';
import { CurrentUserEdit } from '../current-user-edit/current-user-edit';

export const CurrentUserSidebar: FC<{
  onIsOpenedChange?: (value: boolean) => void;
  isOpened?: boolean;
}> = ({ isOpened = false, onIsOpenedChange = () => {} }) => {
  const [isTransferringPermissions, setIsTransferringPermissions] = useState(false);

  return (
    <Drawer
      onClose={() => {
        onIsOpenedChange(false);
        setIsTransferringPermissions(false);
      }}
      open={isOpened}
      handleOnly
    >
      <DrawerContent className="flex flex-col gap-0 overflow-hidden p-0" draggable="false">
        {isTransferringPermissions ? (
          <CurrentUserPermissionTransfer onClose={() => setIsTransferringPermissions(false)} />
        ) : (
          <CurrentUserEdit
            onTransferPermissions={() => setIsTransferringPermissions(true)}
            onSuccess={() => onIsOpenedChange(false)}
          />
        )}
      </DrawerContent>
    </Drawer>
  );
};
